<!-- Variable list panel -->
<div class="actions" *ngIf="bindVariableService.allowedCategories.VARIABLES">
    <button class="btn btn-primary app-button" *wmsFeature="preferences.project.editor.variables"
        [disabled]="bindVariableService.dialogParams.bindMode === 'variable'" title="{{locale.LABEL_CREATE_VARIABLE}}"
        (click)="openDialogWithId('bindingAddVariableModal')"><span class="btn-caption">{{locale.LABEL_ADD}}</span></button>
    <select class="form-control app-select" name="wm-bindvariable-filter-category" [(ngModel)]="variableCategoryFilter"
        (ngModelChange)="onVariableTypeChange(variableCategoryFilter);">
        <!-- TO-DO : filteredVariablesTreeHandler.forceRenderTree(); -->
        <option *ngFor="let item of bindVariableService.variableCategoryList | orderBy:'label' " [value]="item.key">
            {{item.label}}
        </option>
    </select>
    <wms-page-select *ngIf="this.bindVariableService.dialogParams.showPageSelection"></wms-page-select>
    <wms-search id="wm-bindvariable-filter-search" name="wm-bindvariable-filter-search" width="20em"
        placeholder="{{locale.MESSAGE_PLACEHOLDER_SEARCH_VARIABLE_NAME}}"
        (onSearch)="searchVariable($event)"></wms-search>
</div>
<wms-bind-variable-tree [message]="message" [skipChildNodeSearch]="true" [typeVariablesNotFound]="typeVariablesNotFound" [variableSearchKey]="variableSearchKey"></wms-bind-variable-tree>


<wms-dialog id="bindingAddVariableModal" [content]="addVariableContent" customClasses="modal large wm-studio-dialog fade add-new-variable-container-dialog wm-right-panel-container" [closeOnEscape]="false">
</wms-dialog>
<ng-template #addVariableContent>
    <wms-add-variable-config [disableBinding]="true" [serviceTypeGroups]="variableService.serviceTypeGroups" (onModalClose)="closeDialogWithId('bindingAddVariableModal')"></wms-add-variable-config>
</ng-template>
